import { gt, maxValue } from "@src/utils/forms/validators";
import type { NumberModel } from "@src/utils/models";
import { FieldState, FormState } from "formstate";

export class Form {
  amount: FieldState<NumberModel>;

  maxAmount?: NumberModel;

  _form: FormState<FieldState<any>[]>;

  constructor(amount: NumberModel) {
    this.maxAmountValidate = this.maxAmountValidate.bind(this);
    this.amount = new FieldState(amount).validators(
      gt(0),
      this.maxAmountValidate,
    );
    this._form = new FormState([this.amount]);
  }

  private maxAmountValidate($: NumberModel) {
    if (this.maxAmount === undefined) {
      return null;
    }

    return maxValue(this.maxAmount.value)($.value);
  }

  reset() {
    this._form.reset();
  }

  async validate() {
    return this._form.validate();
  }

  serialize() {
    return { amount: this.amount.value.denominatedValue };
  }
}
